export enum CollectionModuleApiSuffixModels {
  CREDIT_NOTES = 'credit-notes',
  UX_CREDIT_NOTES = 'ux/credit-notes',
  UX_CREDIT_NOTES_DESCRIPTION_SUB_TYPE = 'ux/credit-notes-description-sub-type',
  CREDIT_NOTES_UPLOAD = 'credit-notes/upload',
  DEBIT_NOTES_UPLOAD = 'credit-notes/upload',
  BAD_DEBIT_WRITEOFF = 'bad-debit-write-off',
  BAD_DEBIT_WRITEOFF_UPLOAD = 'bad-debit-write-off/upload',
  DOA_DASHBORD_VIEW = 'doa-dashboard-view',
  CREDIT_NOTES_DEACTIVATE = 'credit-notes-deactivate',
  DOA_DETAIL = 'doa-detail',
  DOA_UPDATE = 'doa-update',
  CREDIT_NOTES_DOA_APPROVAL = 'credit-note-doa-approval',
  UX_DEBIT_NOTES = 'ux/debit-notes',
  DEBIT_NOTES = 'debit-notes',
  CREDIT_NOTES_VIEW = 'credit-notes-view',
  VENDOR_REGISTRATION = 'vendor-registration-documents',
  UX_DOCUMENT_TYPE = "ux/vendor-document-types",
  SEND_EMAIL = "vendor-registration-documents/send-email",
  UX_SEARCH_CUSTOMER = "ux/customer-email-addressvendor-document-types",
  VENDOR_DOCUMENT_POST = "vendor-document-types",
  CALL_OUTCOME = 'call-outcome',
  CALL_WRAPUP = 'call-wrapup',
  MAPPING_OUTCOME = 'call-outcome-call-wrapup-mapping',
  UX_CALL_OUTCOME = 'ux/call-outcome',
  UX_CALL_WRAPUP = 'ux/call-wrapup',
  UX_CALL_OUTCOME_CALL_WRAPUP = 'ux/Outcome-CallWrapup',
  CONTRACT_BALANCE_CHARGES = 'contract-balance-charge',
  ENABLE_DISABLE_CONTRACT_BALANCE_CHARGES = 'contract-balance-charge/enable-disable',
  DEBTOR_REMINDER_SMS = 'debtor-reminder-sms',
  UX_DEBTOR_REMINDER_SMS = 'ux/debtor-reminder-sms',
  DEBTOR_REMINDER_SMS_DETAILS ='debtor-reminder-sms/detail',
  CREDIT_CONTROLLER_CODE = "credit-controller-code",
  CREDIT_CONTROLLER_CODE_UX = "ux/credit-controller-code",

  CREDIT_CONTROLLER_STAFF_REGISTRATION = 'credit-controller-staff-registration',
  CREDIT_CONTROLLER_TYPE = 'credit-controller-type',
  CREDIT_CONTROLLER_TYPE_UX = 'ux/credit-controller-type',

  CREDIT_CONTROLLER_CODE_EMPLOYEE = "credit-controller-code-employee",
  CREDIT_CONTROLLER_CODE_EMPLOYEE_UX = "ux/credit-controller-code-employee",


  VENDOR_DOCUMENT_TYPE = 'vendor-document-types',
  DECLINE_REASON = 'decline-reason',
  BANK_STATEMENT_UPLOAD_LIST = 'bank-statement-upload-list',
  BANK_STATEMENT_UPLOAD = 'bank-statement-upload',
  BANK_STATEMENT_DETAIL = 'bank-statement/detail',
  BANK_STATEMENT_TRANSACTIONS = 'bank-statement/transactions',
  PROCESS_BANK_STATEMENT = 'bank-statement-upload/process-bank-statement',
  PROCESSED_TRANSACTIONS = 'bank-statement/processed-transactions',
  PROCESSED_TRANSACTIONS_AMOUNT = 'bank-statement/processed-transaction-amount',
  UPDATE_PROCESSED_BANK_STATEMENT = 'bank-statement/update-processed-statements',
  GENERATE_PAYMENT_BATCH = 'bank-statement/generate-payment-batch',
  PAYMENT_BATCH_LOG = 'bank-statement-upload/payment-batch-log',
  PAYMENT_BATCH_LOG_DETAIL = 'bank-statement-upload/payment-batch-log-detail',
  PAYMENT_BATCH_LOG_DETAIL_LIST = 'bank-statement-upload/payment-batch-log-detail-list',
  BATCH_POSTING_STATUS_LIST = 'bank-statement-upload/batch-posting-status-list',
  BATCH_POSTING_TRANSACTIONS_LIST = '/bank-statement-upload/batch-posting-transaction-list',
  BANK_STATEMENT_ESCALATE_EXCEPTIONS = 'bank-statement/escalate-exceptions',
  BANK_STATEMENT_POST_PAYMENTS = 'bank-statement-upload/post-payments',
  SMALL_BALANCE_WRITEOFF_CONFIG = 'small-balance-writeoff-config',
  SMALL_BALANCE_WRITEOFF_CONFIG_LIST = 'small-balance-writeoff-config/list',
  SMALL_BALANCE_WRITEOFF_CONFIG_DETAILS = 'small-balance-writeoff-config/details',
  SMALL_BALANCE_WRITEOFF_EXCLUSION_SERVICE = 'small-balance-writeoff-exclusion/service',
  SMALL_BALANCE_WRITEOFF_EXCLUSION_SERVICE_LIST = 'small-balance-writeoff-exclusion/service/list',
  SMALL_BALANCE_WRITEOFF_EXCLUSION_SERVICE_DETAILS = 'small-balance-writeoff-exclusion/service/details',
  SMALL_BALANCE_WRITEOFF_EXCLUSION_CATEGORY = 'small-balance-writeoff-exclusion/category',
  SMALL_BALANCE_WRITEOFF_EXCLUSION_CATEGORY_LIST = 'small-balance-writeoff-exclusion/category/list',
  SMALL_BALANCE_WRITEOFF_EXCLUSION_CATEGORY_DETAILS = 'small-balance-writeoff-exclusion/category/details',
  SMALL_BALANCE_WRITEOFF_EXCLUSION_TRANSACTION = 'small-balance-writeoff-exclusion/transaction',
  SMALL_BALANCE_WRITEOFF_EXCLUSION_TRANSACTION_LIST = 'small-balance-writeoff-exclusion/transaction/list',
  SMALL_BALANCE_WRITEOFF_EXCLUSION_TRANSACTION_DETAILS = 'small-balance-writeoff-exclusion/transaction/details',
  SMALL_BALANCE_WRITEOFF_LIST = 'small-balance-writeoff/list',
  SMALL_BALANCE_WRITEOFF_DIVISION_DETAILs = 'small-balance-writeoff/division-details',
  SMALL_BALANCE_WRITEOFF = 'small-balance-writeoff',
  SMALL_BALANCE_WRITEOFF_GENERATE_DEBATOR = 'small-balance-writeoff/generate-debtor-details',
  SMALL_BALANCE_WRITEOFF_GENERATE_DEBATOR_COUNT = 'small-balance-writeoff/generate-debtor-details-count',
  SMALL_BALANCE_WRITEOFF_APPROVE = 'small-balance-writeoff/approve',
  SMALL_BALANCE_WRITEOFF_DECLINE = 'small-balance-writeoff/decline',
  BANK_STATEMENT_CONFIG = 'bank-statement-config',
  UX_BANK_STATEMENT_CONFIGTYPES = 'ux/bank-statement-configtypes',
  BAD_DEBIT_WRITEOFF_DETAIL = 'bad-debit-write-off/detail',
  BAD_DEBIT_WRITEOFF_DOA_DETAIL = 'bad-debit-write-off/doa-detail',
  BAD_DEBIT_RECOVERY = 'bad-debit-recovery',
  BAD_DEBIT_RECOVERY_DETAIL = 'bad-debit-recovery/detail',
  BAD_DEBIT_RECOVERY_DOA_DETAIL = 'bad-debit-recovery/doa-detail',
  BAD_DEBIT_REVERSAL = 'bad-debit-reversal',
  BAD_DEBIT_RECOVERY_REVERSAL = 'bad-debit-reversal/detail',
  BAD_DEBIT_REVERSAL_DOA_DETAIL = 'bad-debit-reversal/doa-detail',
  SMALL_BALANCE_WRITEOFF_DEBATOR = 'small-balance-writeoff/debtor',
  BAD_DEBIT_WRITEOFF_DEBATOR_ESCALATION_DETAILS = 'small-balance-writeoff/debtor-escalation-details',
  ACCOUNT_RATIO = 'account-ratio',
  CALL_ESCALATION_LIST = 'call-escalation-config/list',
  CALL_ESCALATION_DETAILS = 'call-escalation-config/details',
  CALL_ESCALATION_CONFIG = 'call-escalation-config',
  CALL_LOG_STATUS = 'ux/call-log-status',
  UX_CREDIT_CONTROLLER_CUTOFF_DATES = 'ux/credit-controller-cutoff-dates',
  CREDIT_CONTROLLER_CUTOFF_DATES = 'credit-controller-cutoff-dates',
  ASSIGNING_ACCOUNTS = 'assigning-accounts',
  UX_ASSIGNING_ACCOUNTS = 'ux/assigning-accounts',

  ALARM_SYSTEM_MODEL_TYPE = 'alarm-system-model-type',
  ALARM_SYSTEM_COST_TYPE = 'alarm-system-cost-type',
  ALARM_SYSTEM_MODEL_COST_TYPE = 'alarm-system-model-cost-type',
  ALARM_SYSTEM_AMMORTIZATION_PERIOD = 'alarm-system-ammortization-period',
  UX_ALARM_SYSTEM_COST_TYPE = 'ux/alarm-system-cost-type',
  UX_ALARM_SYSTEM_MODEL_TYPE = 'ux/alarm-system-model-type',
  BALANCE_OF_CONTRACT_DETAIL = 'balance-contract/detail',
  BALANCE_OF_CONTRACT_CONFIG = 'balance-contract-config',
  BALANCE_OF_CONTRACT = 'balance-contract',
  UX_DOCUMENT_TYPE_FOR_FILE_UPLOAD = 'ux/document-type',
  BALANCE_OF_CONTRACT_DOA_DASHBOARD = 'balance-contract/doa-dashboard',
  BALANCE_OF_CONTRACT_DOA_APPROVAL = 'balance-contract/doa-approval',
  PURCHASE_OF_ALARM_AMMORTIZATION_SCHEDULE = 'alarm-system-ammortization-schedule',
  PURCHASE_OF_ALARM_AMMORTIZATION_SCHEDULE_TOTAL = 'alarm-system-ammortization-schedule-total',
  PURCHASE_OF_ALARM_AMMORTIZATION_SCHEDULE_DETAIL = 'alarm-system-ammortization-schedule/detail',
  PURCHASE_OF_ALARM_AMMORTIZATION_SCHEDULE_MONTH_DETAIL = 'alarm-system-ammortization-schedule/monthdetail',
  UX_ALARM_SYSTEM_AMMORTIZATION_PERIOD = 'ux/alarm-system-ammortization-period',
  PURCHASE_OF_ALARM_SYSTEM_CANCELLATION_DETAIL = 'purchase-alarm-cancellation/detail',
  PURCHASE_OF_ALARM_SYSTEM_CANCELLATION = 'purchase-alarm-cancellation',
  PURCHASE_OF_ALARM_SYSTEM_CANCELLATION_DOA_APPROVAL = 'purchase-of-alarm-system/doa-approval',
  PURCHASE_OF_ALARM_CANCELLATION_FEE = 'purchase-alarm-cancellation/fees',
  CREDIT_CONTROL_ASSIGN_DEBTOR = 'credit-control-assign-debtor',
  UX_CREDIT_CONTROL_ASSIGN_DEBTOR_VALIDATE = 'ux/credit-control-assign-debtor-validate',
  UX_CREDIT_CONTROL_ASSIGN_DEBTOR_DETAIL = 'ux/credit-control-assign-debtor-detail',
  CREDIT_CONTROL_ASSIGN_DEBTOR_BULK_FILE = 'credit-control-assign-debtor-bulk-file',
  CREDIT_CONTROL_ASSIGN_DEBTOR_BULK = 'credit-control-assign-debtor-bulk',
  CREDIT_CONTROL_MY_TASK_LIST = 'credit-controller-doa-approval',
  UX_CREDIT_CONTROL_ASSIGN_DEBTOR = 'ux/credit-control-assign-debtor',
  CREDIT_AND_REINVOICE = 'credit-and-reinvoice/credit-note',
  CREDIT_AND_REINVOICE_DOA_APPROVAL_CREDI_NOTE = 'credit-and-reinvoice/credit-note-doa-approval',
  CREDIT_AND_REINVOICE_DOA_APPROVAL_INVOICE = 'credit-and-reinvoice/invoice-doa-approval',
  CREDIT_AND_REINVOICE_INVOICE = 'credit-and-reinvoice/invoice',
  CREDIT_AND_REINVOICE_INVOICE_DOA_DETAIL = 'credit-and-reinvoice/invoice-doa-detail',
  CREDIT_AND_REINVOICE_CREDIT_NOTE_DOA_DETAIL = 'credit-and-reinvoice/credit-note-doa-detail',
  BULK_SMS_UPLOAD_LIST = 'bulk-sms-upload-list',
  BULK_SMS_UPLOAD = 'bulk-sms-upload',
  BULK_SMS_UPLOAD_TEMPLATE_LIST = 'bulk-sms-upload/template-list',
  BULK_SMS_UPLOAD_SMS_LIST = 'bulk-sms-upload/sms-list',
  BULK_SMS_UPLOAD_RESPONSE_LIST = 'bulk-sms-upload/response-list',
  OFFSET_DETAIL = 'offsetting/detail',
  OFFSETTING = "offsetting",
  OFFSET_DOA_DETAIL = 'offsetting/doa-detail',
  UX_CREDIT_CONTROLLER = 'ux/credit-controller',
  UX_COLLECTION_CREDIT_CONTROLLER = 'ux/collection/credit-controller',
  UX_CAMPAIGN_FREQUENCY = 'ux/campaign-frequency',
  POTENTIAL_REFUND_DETAIL = 'potential-refund/detail',
  UX_POTENTIAL_REFUND_STATUS = 'ux/potential-refund-status',
  POTENTIAL_REFUND = 'potential-refund',
  SMS_TEMPLATE_BANK_MAPPING = "sms-template-bank-mapping-list",
  SMS_UX_TEMPLATE = 'ux/sms-template',
  SMS_BANK_MAPPING_POST = "sms-template-bank-mapping",
  PROMISE_TO_PAY_DEBATOR_OUTSTANDING = 'promise-to-pay/debtor-outstanding-detail',
  PAYMENT_ARRANGEMENTS_DEBTOR_DETAILS = 'payment-arrangements/debtor-details',
  PROMISE_TO_PAY_DETAIL = 'promise-to-pay/detail',
  PROMISE_TO_PAY_UPDATE = 'promise-to-pay/update',
  UX_COMPANY_BANKS = 'ux/company-banks',
  PROMISE_TO_PAY = 'promise-to-pay',
  REFUNDS_DETAIL = 'refunds/detail',
  REFUNDS_DOA_DETAIL = 'refunds/doa-detail',
  REFUNDS = 'refunds',
  REFUNDS_AVS = 'refunds/avs-check',
  REFUNDS_DOA = 'refunds/doa',
  UX_CALL_ESCALATION_ASSIGN_TO_ROLE = 'ux/call-escalation-config/assign-to-role',
  UX_CALL_ESCALATION_CALL_LOG_STATUS = 'ux/call-escalation-config/call-log-status',
  SPLIT_PAYMENTS = 'split-payments',
  SPLIT_PAYMENTS_DOA = 'split-payments-doa',

  PROMISE_TO_PAY_NOTES_LIST = 'promise-to-pay/notes-list',
  PAYMENT_ARRANGEMENTS_NOTES_DETAIL = 'payment-arrangements/notes-list',
  // UX_OUTCOME_CALLWRAPUP = 'ux/Outcome-CallWrapup',
  // PROOF_OF_PAYMENT = 'proof-of-payment',
  PROOF_OF_DETAILS = 'proof-of-payment/detail',
  CALL_OUT_COME_DROP_DOWN = 'ux/call-outcome',
  CALL_WRAP_UP_CODE = "ux/Outcome-CallWrapup",
  PROOF_OF_NOTE_LIST = 'proof-of-payment/notes-list',
  CALL_ESCALATION_CONFIG_CALL_WRAPUP = 'call-escalation-config/call-wrap-up-time',
  PROOF_OF_PAYMENT_LIST = 'proof-of-payment-list',
  PROOF_OF_NOTE_POST = 'proof-of-payment/notes',
  SMS_TEMPLATE_DETAIL = "sms-template-bank-mapping/detail",
  PRODUCTIVITY_TARGET_LIST = 'productivity-target-list',
  PRODUCTIVITY_TARGET_DETAIL = 'productivity-target/detail',
  PRODUCTIVITY_TARGET = 'productivity-target',

  PRODUCTIVITY_TARGET_EXCLUSION_LIST = 'productivity-target-exclusion-list',
  PRODUCTIVITY_TARGET_EXCLUSION_DETAIL = 'productivity-target-exclusion/detail',
  PRODUCTIVITY_TARGET_EXCLUSION = 'productivity-target-exclusion',
  PRODUCTIVITY_DASHBOARD_OVERVIEW = 'productivity-dashboard/overview',
  PRODUCTIVITY_DASHBOARD_SUMMARY = 'productivity-dashboard/summary',
  PRODUCTIVITY_DASHBOARD_NOTE_COUNTS = 'productivity-dashboard/note-counts',
  UX_OUTCOME_CALLWRAPUP = 'ux/Outcome-CallWrapup',
  PROOF_OF_PAYMENT = 'proof-of-payment',
  BULK_BAD_DEBIT_CONFIG = 'bulk-bad-debit-config',
  BULK_BAD_DEBIT_CONFIG_DETAIL = 'bulk-bad-debit-config/detail',
  BULK_BAD_DEBIT_MANAGEMENT = 'bulk-bad-debit-management',
  BULK_BAD_DEBIT_MANAGEMENT_DETAIL = 'bulk-bad-debit-management/detail',
  BULK_BAD_DEBIT_MANAGEMENT_EXPORT = 'bulk-bad-debit-management/export',
  BULK_BAD_DEBIT_MANAGEMENT_CONSOLIDATED_DETAIL = 'bulk-bad-debit-management/consolidated-detail',
  BULK_BAD_DEBIT_MANAGEMENT_DASHBOARD = 'bulk-bad-debit-management/dashboard',
  BULK_BAD_DEBIT_MANAGEMENT_DOWNLOAD = 'bulk-bad-debit-management/download',
  BULK_BAD_DEBIT_MANAGEMENT_FILE_UPLOAD = 'bulk-bad-debit-management/file-upload',
  BULK_BAD_DEBIT_MANAGEMENT_CHECK_ACTIVE_STATUS = 'bulk-bad-debit-management/check-active-status',
  BULK_BAD_DEBIT_MANAGEMENT_DOA = 'bulk-bad-debit-management/doa',
  BULK_BAD_DEBIT_MANAGEMENT_DOA_APPROVAL = 'bulk-bad-debit-management/doa-approval',


  INCENTIVE_REDUCTION_TYPES = 'incentive-reduction-types',
  INCENTIVE_REDUCTION_RISK_LEVEL = 'incentive-reduction-risk-level',
  INCENTIVE_STRUCTURE = 'incentive-structure-config',
  INCENTIVE_CRITERIA = 'incentive-criteria',
  UX_INCENTIVE_STRUCTURE = 'ux/incentive-structure-config',
  UX_INCENTIVE_TARGET_PERCENTAGE = 'ux/incentive-target-percentage-qualifying-level-config',
  UX_INCENTIVE_REDUCTION_TYPES = 'ux/incentive-reduction-types',
  UX_INCENTIVE_REDUCTION_RISK_LEVEL = 'ux/incentive-reduction-risk-level',
  INCENTIVE_TARGETPERCENTAGE = 'incentive-target-percentage-qualifying-level-config',

  CREDIT_CONTROL_COMPIGN_DROPDOWN = 'ux/credit-controller-campaign',
  COMPIGN_REGION_LIST = "ux/campaign-region",
  CREDIT_CONTROL_DASHBOARD = 'dashboard/detail',
  FINAL_DEMAND_REJECTECTION_REASON = 'final-demand-rejection-reason',
  PAYMENT_ARRANGEMENTS_LIST = 'payment-arrangements-list',
  PAYMENT_ARRANGEMENTS_DETAILS = 'payment-arrangements/details',
  PAYMENT_ARRANGEMENTS_EXTENDED_DETAILS = 'payment-arrangements/extended-details',
  PAYMENT_ARRANGEMENTS = 'payment-arrangements',
  UX_FINAL_DEMAND_REJECTECTION_REASON = 'ux/final-demand-rejection-reason',
  BAD_DEBT_SUSPENSION_FINAL_DEMAND_LIST = 'bad-debt-suspension-final-demand-list',
  BAD_DEBT_SUSPENSION_POTENTIAL_SUSPENSION_LIST = 'bad-debt-suspension-potential-suspension-list',
  BAD_DEBT_SUSPENSION_POTENTIAL_SUSPENSION_TOTAL_LIST = 'bad-debt-suspension-potential-suspension-total-list',
  BAD_DEBT_SUSPENSION_FINAL_DEMAND_TOTAL_LIST = 'bad-debt-suspension-final-demand-total-list',
  BAD_DEBT_SUSPENSION_FINAL_DEMAND = 'bad-debt-suspension-final-demand',
  BAD_DEBT_SUSPENSION_POTENTIAL_SUSPENSION = 'bad-debt-suspension-potential-suspension',
  BAD_DEBT_SUSPENSION_POTENTIAL_SUSPENSION_DOA_DETAIL = 'bad-debt-suspension/potentail-suspension-doa-detail',
  BAD_DEBT_SUSPENSION_FINAL_DEMAND_HEADER = 'bad-debt-suspension/final-demand-header-detail',
  BAD_DEBT_SUSPENSION_POTENTIAL_SUSPENSION_DOA = 'bad-debt-suspension/potential-suspension-detail',
  BAD_DEBT_SUSPENSION_FINAL_DEMAND_DOA_DETAIL = 'bad-debt-suspension/final-demand-doa-detail',
  BAD_DEBT_SUSPENSION_FINAL_DEMAND_DETAIL = 'bad-debt-suspension/final-demand-detail',
  BAD_DEBT_SUSPENSION_DOA = 'bad-debt-suspension/doa',
  BAD_DEBT_REINSTATEMENT_SUSPENDED_DETAIL = 'bad-debt-reinstatement/suspended-details',
  BAD_DEBT_REINSTATEMENT = 'bad-debt-reinstatement',
  MANAGER_DASHBOARD_SUPERVISOR_API = 'ux/child-users',
  CREDIT_CONTROL_MANAGER_COMPIGN_DROPDOWN = "ux/manager-credit-controller-campaign",
  CREDIT_CONTROL_SUPERVISOR_DASHBOARD_COMPIGN_DROPDOWN = 'ux/supervisor-credit-controller-campaign',
  PROOF_OF_PAYMENT_DOCUMENT_DETAILS = 'proof-of-payment/document-list',
  NIMBLE_EXCLUSION = 'nimble-exclusion',
  UX_NIMBLE_EXCLUSION = 'ux/nimble-exclusion',
  NIMBLE_SOLD_ACCOUNTS='nimble-sold-accounts',
  NIMBLE_SOLD_ACCOUNTS_DETAIL='nimble-sold-accounts-detail',
  NIMBLE_SOLD_ACCOUNTS_BULK='nimble-sold-accounts-bulk',
  NIMBLE_SOLD_ACCOUNTS_BULK_DETAIL='nimble-sold-accounts-bulk-detail',
  NIMBLE_SOLD_ACCOUNTS_REPORT='nimble-sold-accounts-report',
  WRITE_OF_ACCOUNTS='write-off-accounts',
  WRITE_OF_ACCOUNTS_CREDIT_CONTROLLER='write-off-accounts-credit-controller',
  WRITE_OF_ACCOUNTS_FILTER='write-off-accounts-filter',
  WRITE_OF_ACCOUNTS_BULK='write-off-accounts-bulk',
  WRITE_OF_ACCOUNTS_BULK_DETAIL='write-off-accounts-bulk-detail',
  CREDIT_CONTROL_LETTER='certificate-balance',
  PAYMENT_ARRANGEMENTS_NOTES  = 'payment-arrangements/notes',
  REFUSE_TO_PAY_REASON = 'refuse-to-pay-reasons',
  UX_REFUSE_TO_SUBREASONS = 'ux/refuse-to-pay-sub-reasons',
  REFUSE_SUB_REASON = 'refuse-to-pay-sub-reasons',
  FIANL_DEMAND_LIST = 'final-demand-list',
  POTENTIAL_SUSPENSION_LIST = 'potential-suspension-list',

  CESSION_LETTERS = 'cession-letters',
  INCENTIVE_MANUAL_OPENING='incentive-manual-opening',
  INCENTIVE_MANUAL_OPENING_DETAILS='incentive-manual-opening-details',
  INCENTIVE_MANUAL_CLOSING='incentive-manual-closing',
  INCENTIVE_MANUAL_CLOSING_DETAILS='incentive-manual-closing/detail',
  INCENTIVE_AUTOMATED_OPENING='incentive-automated-opening',
  INCENTIVE_AUTOMATED_OPENING_DETAILS='incentive-automated-opening-details',
  INCENTIVE_AUTOMATED_CLOSING='incentive-automated-closing',
  INCENTIVE_AUTOMATED_CLOSING_DETAILS='incentive-automated-closing/detail',
  NIMBLE_LETTER = 'nimble-letters',
  NIMBLE_LETTER_TO_DEBTORS  = 'nimble-letters-to-debtors',
  NIMBLE_LETTER_REPORT  = 'nimble-letters-report',
  NIMBLE_LETTER_REPORTS = 'nimble-letters-reports',

  NO_CONTACT_LIST = 'no-contact-list',
  NO_CONTACT_KEYHOLDERS = 'no-contact/keyholers',
  NO_CONTACT = 'no-contact',
  UX_REFUSE_TO_REASONS = 'ux/refuse-to-pay-reasons',
  REFUSE_TO_PAY ='Refuse-to-pay',
  ACCEPT_SAVEOFFERDISCOUNT = 'Refuse-to-pay/accept-offer',
  REFUSE_TO_PAY_DETAILS ='Refuse-to-pay/details',
  NO_CONTACT_DETAIL = 'no-contact/detail',
  UX_MANUAL_INVOICE_DECLINE_REASON = 'ux/manual-invoice/decline-reason',
  NO_CONTACT_DECLINE = 'no-contact/decline',
  NO_CONTACT_APPROVE = 'no-contact/approve',
  NO_CONTACT_REQUEST_ITC_DETAIL = 'no-contact/request-itc-detail',
  NO_CONTACT_ADD_NOTES = 'no-contact/notes',
  NO_CONTACT_ADD_NOTES_LIST = 'no-contact/notes-list',
  INCENTIVE_GENERATE_REPORT_UX_REGION_DEIVISON = 'incentive-generate-report-ux-region-division',
  INCENTIVE_GENERATE_REPORT    = 'incentive-generate-report',

  NO_CONTACT_EDIT_DETAIL = 'no-contact/edit-detail',
  NO_CONTACT_ITC_TRACE = 'no-contact/itc-trace',

  REFUSE_TO_PAY_NOTES = 'Refuse-to-pay/notes',
  REFUSE_TO_PAY_NOTES_LIST = 'Refuse-to-pay/notes',

  NO_CONTACT_COLLECTION_TRACE_DETAIL = 'no-contact/collection-trace-detail',
  NO_CONTACT_STRIKE_DATE_TRACE_DETAIL = 'no-contact/strikedate-trace-detail',
  CORRESPONDENCE_LOG_LIST =  'correspondence-log-list',
  CORRESPONDENCE_LOG_MARKETING_LIST =  'correspondence-log-marketing-list',

  // REINSTEMENT
  REINSTATEMENTS_LIST = 'incentive-reinstament',
  CREDIT_CONTROL_MANAGER='ux/credit-control-manager',
  CREDIT_CONTROL_CHILD_MANAGER='ux/reporting-child-users',
  TRANSFERS_DETAIL = 'transfers/detail',
  TRANSFERS = 'transfers',
  ADVANCED_SEARCH_DEBTORS_BY_ID='advanced-search/debtorsById',
  TRANSFER_DOA_DETAILS='transfers/doa-detail',
  TRANSFER_DOA_DETAILS_APPROVAL='payment-transfer-doa-approval',
  TRANSFER_APPROVE_DECLINE = 'payment-transfer-doa-approval',

  CREDIT_NOTES_MULTIPLE_INVOICE = 'credit-notes-multipleinvoice',
  BAD_DEBT_REINSTATEMENT_VALIDATE_SUSPENDED_DETAILS = 'bad-debt-reinstatement/validate-suspended-details',
}
export enum CALL_OUTCOME_FEATURE_NAME {
  CALL_OUTCOME = 'call-outcome',
  CALL_WRAPUP = 'call-wrapup',
  MAPPING_OUTCOME = 'mapping-outcome'
}

export enum SMALL_BALANCE_EXCLUSION {
  SERVICES = 'services',
  CATEGORIES = 'categories',
  TRANSACTIONS = 'transactions'
}

export enum COLLECTION_COMPONENT {
  BAD_DEBT_SUSPENSION ="Bad Debt Suspension",
  FINAL_DEMAND="Final Demand",
  POTENTIAL_SUSPENSION="Potential Suspension",
  MY_TASK="My Task",
  VENDOR_REGISTRATION="Vendor Registration",
  BANK_STATEMENT_UPLOADS="Statement Uploads",
  STATEMENT_UPLOADS="Statement Uploads",
  POSTING_BATCHES_LOGS="Posting batches Logs",
  POSTED_FILE_STATUS="Posted file status",
  BULK_BAD_DEBT_MANAGEMENT ="Bulk Bad Debt Management",
  CALL_WRAP_UP_CODES="Call wrap up codes",
  NO_CONTACT="No Contact",
  PAYMENT_ARRANGEMENT="Payment Arrangement",
  PROMISE_TO_PAY="Promise To Pay",
  PROOF_OF_PAYMENT="Proof Of Payment",
  REFUSE_TO_PAY="Refuse To Pay",
  CAMPAIGN_ALLOCATION="Campaign Allocation",
  PAYAT_RECONCILIATION="PayAt Reconciliation",
  INCENTIVES_CALCULATION="Incentives Calculation",
  BULK_SMS="Bulk SMS",
  INDIVIDUAL_SMS="Individual SMS",
  MANAGER_DASHBOARD ="Manager Dashboard ",
  SOLD_ACCOUNTS="Sold Accounts",
  WRITTEN_OFF_ACCOUNTS="Written Off Accounts",
  SMALL_BALANCE_WRITE_OFF="Small Balance Write Off",
  PRODUCTIVITY_DASHBOARD="Productivity Dashboard",
  BULK_ASSIGNMENT="Bulk Assignment"
  }
